<style lang='less' scoped>
* {list-style-type: none;}
.center {width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;justify-content:center;align-items:center;}
.photo {width: 100%;overflow: hidden;
  img {width: 100%;overflow: auto;user-select: none;height:100%;display: block;}
  #downup {font-weight: bolder;font-size: 20px;color: #fff;position: relative;top: -20px;}
  #downup:hover {cursor: pointer;}
  .text {overflow:hidden;background: linear-gradient(to top, #1877CB 0%,#115290 100%);
    .bottom {width: 1200px;line-height: 16px;margin: 0px auto;height: 100px;
      .content {font-size: 18px;letter-spacing: 1px; overflow: hidden;color: #fff;display: inline-block;margin: 0px 36px;height: 60%;text-align: left;margin-top: 20px;line-height: 30px;}
    }
  }
}
.sub{list-style: none;width: 800px;display: flex;justify-content: space-between;margin: 20px auto; margin-top: 60px;
  .el-button{font-size: 18px;}
}
.kyzx{margin: 20px;margin-top: 40px;}
.first{display: flex;justify-content:space-between;width: 1200px;}
.country{width:1200px;margin: auto;}
.block{width: 65%;}
.real-time{width:32%; height: 505px;position: relative;overflow-y: hidden;}
.moreNews{font-size:13px;font-weight: 500;}
.moreNews:hover{color: #3c77bb;cursor: pointer;}
.dhnews {margin: 20px auto;height: 580px;display: flex;flex-direction: column;position: relative;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex; flex-direction: column;
  i {width: 200px; height: 3px;display: inline-block;background: #3c77bb;margin: auto; }}
  .dhcard{list-style: none;margin: 0;padding: 0;width: 1200px;overflow-x: hidden;
  li{margin: 0px 10px;width: 280px;height: 420px; padding: 0px; border-radius: 0px 0px 10px 10px;box-shadow: 0px 0px 3px 1px rgb(228, 227, 227);overflow: hidden;cursor: pointer;}
  li:hover{h3{color: #3c77bb;}}
  img{width: 100%; height: 160px;}
  h3{text-align: left;margin: 10px;display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;overflow: hidden; text-overflow: ellipsis;}}
  .moreNews{font-size:13px;font-weight: 500;}
  .moreNews:hover{color: #3c77bb;cursor: pointer;}
  .dhnewscenter{position: relative;width: 1200px;overflow: hidden;
    .container3{width: 1200px;
      .dhcard {list-style: none; display: flex;width: 560000000px;}
    }
  }
}
.chcyg {width: 1400px; margin: auto;margin-top: 80px;
  img { width: 100%;}
}
.nyajb {width: 1200px;margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}}
  .jbname {display: flex;justify-content: space-between;padding: 0;flex-wrap: wrap;
    li {width: 13%;height: 310px;display: flex;flex-direction: column;margin: 15px 40px;
      h4 {padding: 0 10px;margin: 0; line-height: 30px;}
      span {color: #9f9f9f;padding: 0 5px; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4; -webkit-box-orient: vertical;text-align: left;line-height: 24px;font-size: 13px; }
    }
  }
}
.dhyc { width: 1200px;margin: 20px auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
  /deep/.el-select{margin-left: 50px;width: 545px;margin-bottom: 10px;}
}
.zbdw {width: 1200px;margin: 20px auto; display: flex;flex-direction: column;height: 180px;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
  .lgon {display: flex;justify-content: center;padding: 0;
    li {margin: 0 40px;}
  }
}
.cbdw {width: 1200px;margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
  .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap; margin: 0;
    li {height: 80px;line-height: 80px; margin: 20px 40px;}
  }
}
.cbdw2 {width: 1200px; margin: auto;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px; height: 3px;display: inline-block; background: #3c77bb;margin: auto;}
  }
  .lgon {display: flex;justify-content: center;padding: 0;flex-wrap: wrap;margin: 0;
    li {height: 120px;line-height: 120px;margin: 20px 50px;}
  }
}
.xsyz{width:1200px;margin: 50px auto;}
.listdata{width: 100px;font-size: 12px;border-radius: 5px;background-color: #ECF6FF;z-index: 1;margin-right: 10px}
.prevVideo{position: absolute;top: 305px;left:12px;width: 39px;height: 64px;cursor: pointer;z-index: 99;}
.nextVideo{position: absolute;top: 305px;right:12px;width: 39px;height: 64px;cursor: pointer;z-index: 99;}
.topVideo{position: absolute;top: 0px;left:160px;width: 64px;height: 39px;cursor: pointer;z-index: 99;}
.bottomVideo{position: absolute;bottom: 2px;left:160px;width: 64px;height: 39px;cursor: pointer;z-index: 99;}
.hotNews {text-align: left;margin: auto;
  ul {position: relative;list-style: none;margin-top: 0px;padding: 0px;overflow-y: hidden;height: 5050000px;
    li {border-top: 1px solid #cccccc;padding: 10px 0;height: 80px;cursor: pointer;display: flex;overflow-y: hidden;}
  }
  .picbox{width: 100px; height: 80px;overflow: hidden;}
  .pic{margin-top: -3px;}
  .box{position: absolute;left: 110px;width: 200px;}
  .titleIcon {line-height: 25px;white-space: nowrap;}
  .title {float: left;margin: -6px 8px 0px 0px;font-size: 15px;font-weight: 600;max-width: 230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .icon {position: absolute;top:-2px;}
  .text {font-size: 13px; width: 270px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;color: #666666;margin: 8px 0;}
  .text{height: 28px;line-height: 14px; overflow:hidden;}
  .text::after{content: ' ... ';}
  .time{font-size: 13px;color: #000000;}
  .box:hover {color: #13569e;}
  .font1{font-size: 18px;font-weight: bold;}
}
</style>

<template>
  <div class="center">
    <div class="photo" id="photo">
      <img src="static/index/advent2022.png" alt="" />
    </div>
    <ul class="sub">
      <li><router-link to="/Ltgk"><el-button type="primary">论坛概况</el-button></router-link></li>
      <li><el-button type="primary" @click='toHyrc'>会议日程</el-button></li>
      <li><el-button type="primary" class="button1" @click="downLoad('static/pdf/han.pdf')">会议邀请函</el-button></li>
      <li><el-button type="primary" @click='toSignup'>参会报名</el-button></li>
    </ul>
    <p style="line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex; flex-direction: column;">
      <span>会议资讯</span>
      <i style="width: 200px; height: 3px;display: inline-block;background: #3c77bb;margin: auto;"></i>
      <span class="moreNews" @click="goNews">更多会议资讯</span>
    </p>
    <div class="first">
      <div class="block">
        <SwiperImg :widthCSH="800" :heightCSH="505" :swiperlist="Swiperlist" @clickSwiper="goDetails"></SwiperImg>
      </div>
      <div class="real-time" @mouseover="mouseOver2()" @mouseleave="mouseLeave2()">
        <img v-show="isShow2" class="topVideo" src="../../../../static/index/ic_xs.png" alt="" @click="upward" />
        <div class="hotNews">
          <ul class="content" :style="{'margin-top': margintopt + 'px'}">
            <li v-for="(item, index) in hotNewslist" :key="index"  @click="goDetails(item)">
              <div class="picbox">
                <img class="pic" :src="item.pic" style="height: 100%;" />
              </div>
              <div class="box">
                <div class="titleIcon">
                  <span class="title">{{ item.title }} </span>
                  <img class="icon" v-if="index === 0" src="static/index/toutiao.png" />
                  <img class="icon" v-if="index > 0" src="static/index/zuixin.png" />
                </div>
                <p class="text"> {{ item.text }} </p>
                <span class="time">{{item.time * 1000 | formatDate()}}</span>
              </div>
            </li>
          </ul>
        </div>
        <img v-show="isShow2" class="bottomVideo" src="../../../../static/index/ic_xx.png" alt="" @click="down" />
      </div>
    </div>
    <div class="dhnews" id="dhxw" @mouseover="mouseOver()" @mouseleave="mouseLeave()">
      <p>
        <span>大会新闻</span>
        <i></i>
        <span class="moreNews" @click="more">更多大会新闻</span>
      </p>
      <img v-show="isShow" class="prevVideo" src="../../../../static/index/ic_zh.png" alt="" @click="prev()" />
      <div class="dhnewscenter">
        <div class="container3" :style="{'margin-left': marginLeft + 'px'}">
          <ul class="dhcard">
            <li v-for="(item, index) in newslist" :key="index" @click="goDetails1(item)">
              <img :src="item.dir" alt="" />
              <h3>{{ item.title }}</h3>
              <div style="margin: 10px;text-align:left;">{{ item.content }}</div>
            </li>
          </ul>
        </div>
      </div>
      <img v-show="isShow" class="nextVideo" src="../../../../static/index/ic_yh.png" alt="" @click="next()" />
    </div>
    <div class="chcyg">
      <img src="static/index/参会国家.png" alt="" />
    </div>
    <div class="nyajb" id="yjjb">
      <p>
        <span>往届嘉宾</span>
        <i></i>
      </p>
      <ul class="jbname">
        <li v-for="(item, index) in jblist" :key="index">
          <img :src="item.dir" alt="" />
          <h4>{{ item.name }}</h4>
          <span>{{ item.brief }}</span>
        </li>
      </ul>
    </div>
    <div class="dhyc" id="hyrc">
      <p>
        <span>大会议程</span>
        <i></i>
      </p>
      <el-select v-model="meetingid" clearable placeholder="请选择会议" @change="onchange">
        <el-option
          v-for="item in meetings"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <AgendaTabs :TabsList="TabsList"></AgendaTabs>
    </div>
    <div class="zbdw">
      <p>
        <span>主办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in logolist" :key="index">
          <img :src="item" alt="" style="width:320px" />
        </li>
      </ul>
    </div>
    <div class="cbdw">
      <p>
        <span>承办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in logolist2" :key="index">
          <img :src="item" alt="" style="width:320px; vertical-align: middle;" />
        </li>
      </ul>
    </div>
    <div class="cbdw2"  id="xbdw">
      <p>
        <span>协办单位</span>
        <i></i>
      </p>
      <ul class="lgon">
        <li v-for="(item, index) in logolist3" :key="index">
          <img :src="item" alt="" style="width:300px; vertical-align: middle;" />
        </li>
      </ul>
    </div>
    <div class="xsyz">
      <router-link :to="{path: '/Exhibition'}">
        <img src="static/images/zlkindex/xsyz.png">
      </router-link>
    </div>
  </div>
</template>

<script>
/**
 * 罗志远 矿业论坛首页
 */
import AgendaTabs from '../../app/assembly/AgendaTabs'
import SwiperImg from '../assembly/SwiperImg'
import HotNews from '../assembly/HotNews'
import arrayFun from '../method/array.js'
import filters from '../method/filter.js'
export default {
  components: { AgendaTabs, SwiperImg, HotNews },
  mixins: [filters],
  data()
  {
    return {
      swiperlist: [],
      hotNewslist: [],
      newslist: [], // 大会新闻
      jblist: [
        {
          dir: 'static/images/zlkindex/凌月明.png',
          name: '凌月明',
          brief: '自然资源部党组成员、副部长'
        },
        {
          dir: 'static/images/zlkindex/严值禅.png',
          name: '严值禅',
          brief: '第十九届中央候补党员,广西壮族自治区第十一届委员'
        },
        {
          dir: 'static/images/zlkindex/黄世勇.png',
          name: '黄世勇',
          brief: '广西壮族自治区副主席'
        },
        {
          dir: 'static/images/zlkindex/黄瀚.png',
          name: '黄瀚',
          brief: '广西壮族自治区人民政府副秘书长'
        },
        {
          dir: 'static/images/zlkindex/唐善茂.png',
          name: '唐善茂',
          brief: '广西壮族自治区地质矿产勘查开发局局长'
        },
        {
          dir: 'static/images/zlkindex/柯雪利.png',
          name: '柯雪利',
          brief: '广西盛隆冶金有限公司总经理'
        },
        {
          dir: 'static/images/zlkindex/吴国华.png',
          name: '吴国华',
          brief: '中国矿业联合会副会长'
        },
        {
          dir: 'static/images/zlkindex/蔡建勇.png',
          name: '蔡建勇',
          brief: '宁波力勤资源科技开发有限公司董事长'
        },
        {
          dir: 'static/images/zlkindex/赵占国.png',
          name: '赵占国',
          brief: '中国黄金集团有限公司副总经理'
        },
        {
          dir: 'static/images/zlkindex/董建雄.png',
          name: '董建雄',
          brief: '中国铝业集团有限公司副总经理'
        }
      ],
      logolist: [
        'static/company/广西壮族自治区人民政府.png',
        'static/company/中华人民共和国资源部.png'
      ],
      logolist2: [
        'static/company/广西壮族自治区国土资源厅.png',
        'static/company/中国地质调查局国际矿业研究中心.png',
        'static/company/自然资源部科技与国际合作司.png',
        'static/company/广西壮族自治区地质矿产勘查开发局.png'
      ],
      logolist3: [
        'static/company/中国自然资源经济研究院.png',
        'static/company/自然资源部国土卫星遥感应用中心.png',
        'static/company/中国地质博物馆.png',
        'static/company/中国矿业联合会.png',
        'static/company/中国黄金协会.png',
        'static/company/中国地质调查局国际矿业研究中心.png',
        'static/company/中国—东盟地学合作中心.png',
        'static/company/南方石山地区矿山地质环境修复工程技术创新中心.png',
        'static/company/自然资源广西卫星应用技术中心.png',
        'static/company/中铝广西有色稀土开发有限公司.png',
        'static/company/广西国际博览事务局.png',
        'static/company/桂林理工大学.png',
        'static/company/中国—东盟中心.png',
        'static/company/联合国教科文组织国际岩溶研究中心.png',
        'static/company/东盟国家矿业协会联合会.png'
      ],
      TabsList: [],
      marginLeft: 0,
      margintopt: 0,
      isShow: false,
      isShow2: false,
      meetings: [],
      meetingid: null
    }
  },
  computed:
  {
    Swiperlist()
    {
      return this.swiperlist
    },
    HotNewslist()
    {
      return this.hotNewslist
    },
    Cardlist()
    {
      return this.cardlist
    },
    HotNewsdata()
    {
      return this.hotNewsdata
    }
  },
  mounted()
  {
    this.getKyzx()
    this.getNews()
    this.getHyrc(2)
    this.getKyltm()
  },
  watch:
  {
    $route: {
      async handler(nval, oval)
      {
        await document.querySelector('#hyrc')
        if (nval.query.kw === 'hyrc')
          document.querySelector('#xbdw').scrollIntoView({ block: 'end', behavior: 'smooth' })
      },
      immediate: true
    }
  },
  methods: {
    onchange(meetingID)
    {
      this.getHyrc(meetingID)
    },
    // 获取矿业资讯数据
    getKyzx()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        ret[0].data.forEach(item =>
        {
          this.swiperlist.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title})
          this.hotNewslist.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, text: item.introduce, time: item.addtime, hits: item.hits})
        })
      })
    },
    //获取大会新闻数据
    getNews()
    {
      this.marginLeft = 0
      let paras = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.newslist = []
        ret[0].data.forEach(item =>
        {
          this.newslist.push({id: item.id, dir: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, content: item.introduce})
        })
      })
    },
    //获取会议列表
    getKyltm()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 105, _exp: 'id>0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.meetings = []
        ret[0].data.forEach(item =>
        {
          this.meetings.push(
            {
              value: item.id,
              label: item.name
            }
          )
        })
      })
    },
    //获取会议日程数据
    getHyrc(num)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 34, _exp: `catid=${421} and meetingid = ${num}`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          let temp = []
          temp.push({id: '0', title: ret[0].data, content: []})
          for (let i = 1; i < ret.length; i++)
          {
            if (ret[i].data !== ret[i - 1].data)
              temp.push({id: i.toString(), title: ret[i].data, content: []})
          }
          for (let i = 0; i < temp.length; i++)
          {
            for (let j = 0; j < ret.length; j++)
            {
              if (ret[j].data === temp[i].title)
                temp[i].content.push({id: ret[j].id, time: ret[j].times, arrangement: ret[j].content})
            }
            temp[i].content = temp[i].content.sort(arrayFun.compareStoB('id'))
          }
          this.TabsList = temp
        }
      })
    },
    //更多大会新闻
    more()
    {
      let url = this.$router.resolve({path: '/NewsListApp'})
      window.open(url.href, '_blank')
    },
    goNews()
    {
      let url = this.$router.resolve({path: '/NewsListApp', query: {id: 438}})
      window.open(url.href, '_blank')
    },
    // 跳转到大会新闻详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/DhxwDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    goDetails1(item)
    {
      let url = this.$router.resolve({path: '/DhxwDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    onhandleClick(index)
    {
      this.$store.commit('onKyltID', index.id)
      let url = this.$router.resolve({path: '/DhxwDetails'})
      window.open(url.href, '_blank')
    },
    // 下载邀请函
    downLoad(router)
    {
      window.open(router, '_blank')
    },
    toHyrc()
    {
      document.querySelector('#hyrc').scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    // 向左翻
    prev()
    {
      if (this.marginLeft >= 0)
        return false
      this.marginLeft += 300
    },
    // 向右翻
    next()
    {
      if (this.marginLeft === -((this.newslist.length - 4) * 300))
        this.marginLeft = 0
      else
        this.marginLeft -= 300
    },
    // 向上翻
    upward()
    {
      if (this.margintopt >= 0)
        return false
      this.margintopt += 101
    },
    toSignup()
    {
      window.open('https://www.camining.cn/nav/index.html', '_blank')
    },
    // 向下翻
    down()
    {
      if (this.margintopt <= -((this.hotNewslist.length - 5) * 101))
        return false
      this.margintopt -= 101
    },
    mouseOver()
    {
      this.isShow = true
    },
    mouseLeave()
    {
      this.isShow = false
    },
    mouseOver2()
    {
      this.isShow2 = true
    },
    mouseLeave2()
    {
      this.isShow2 = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/PromoinApp.vue